import { Filter as FilterIcon, Spinner } from 'components/shared/icons/ui';
import { useUI } from 'hooks';
import { useRouter } from 'next/router';

const Toolbar = ({
  style = {},
  className = '',
  t,
  sort,
  sortUrls = {},
  isLoading,
  activeFiltersCount,
}) => {
  const { push } = useRouter();
  const tSort = name => t(`sortBy - ${name}`, name);
  const { toggleFilter } = useUI();

  const change = e =>
    push(sortUrls[e.target.value], null, {
      shallow: true,
    });

  return (
    <div
      style={style}
      className={`pointer-events-none flex items-center justify-between p-[16px] text-[12px]  ${className}`}
    >
      <div className="pointer-events-auto flex h-7 items-center gap-[4px] overflow-hidden pl-[6px]">
        <button type="button" className="flex items-center gap-[4px]" onClick={toggleFilter}>
          <FilterIcon className="mt-[-2px]" />
          <span className="font-bold">
            {t('filter - filters', 'Filters')}
            {activeFiltersCount && activeFiltersCount > 0 ? ` ${activeFiltersCount}` : ''}
          </span>
        </button>
        {isLoading && <Spinner className="-mt-0.5 h-7 w-7" />}
      </div>
      <label className="pointer-events-auto flex gap-[4px]" htmlFor="sort">
        <span className="inline-block">{t('sortBy - sortBy', 'Sort by')}:</span>
        <select
          id="sort"
          className="w-[4.5rem] appearance-none overflow-x-hidden truncate whitespace-nowrap bg-transparent font-bold outline-none md:w-auto"
          onChange={change}
          value={sort}
        >
          {Object.keys(sortUrls).map(option => (
            <option key={option} className="font-normal" value={option}>
              {tSort(option)}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default Toolbar;
